import { useLayoutEffect, useMemo, useRef, useState } from 'react';
import { Expand } from 'lucide-react';

const DESKTOP_PATTERNS = {
  1: [
    {
      rows: 7,
      cells: [{ column: 1, columnSpan: 12, row: 1, rowSpan: 7 }],
    },
  ],
  2: [
    {
      rows: 8,
      cells: [
        { column: 1, columnSpan: 5, row: 1, rowSpan: 8 },
        { column: 6, columnSpan: 7, row: 1, rowSpan: 8 },
      ],
    },
    {
      rows: 8,
      cells: [
        { column: 1, columnSpan: 7, row: 1, rowSpan: 8 },
        { column: 8, columnSpan: 5, row: 1, rowSpan: 8 },
      ],
    },
  ],
  3: [
    {
      rows: 8,
      cells: [
        { column: 1, columnSpan: 5, row: 1, rowSpan: 8 },
        { column: 6, columnSpan: 7, row: 1, rowSpan: 4 },
        { column: 6, columnSpan: 7, row: 5, rowSpan: 4 },
      ],
    },
    {
      rows: 8,
      cells: [
        { column: 1, columnSpan: 7, row: 1, rowSpan: 4 },
        { column: 8, columnSpan: 5, row: 1, rowSpan: 8 },
        { column: 1, columnSpan: 7, row: 5, rowSpan: 4 },
      ],
    },
  ],
  4: [
    {
      rows: 8,
      cells: [
        { column: 1, columnSpan: 4, row: 1, rowSpan: 8 },
        { column: 5, columnSpan: 4, row: 1, rowSpan: 8 },
        { column: 9, columnSpan: 4, row: 1, rowSpan: 4 },
        { column: 9, columnSpan: 4, row: 5, rowSpan: 4 },
      ],
    },
    {
      rows: 8,
      cells: [
        { column: 1, columnSpan: 6, row: 1, rowSpan: 4 },
        { column: 7, columnSpan: 6, row: 1, rowSpan: 4 },
        { column: 1, columnSpan: 3, row: 5, rowSpan: 4 },
        { column: 4, columnSpan: 9, row: 5, rowSpan: 4 },
      ],
    },
  ],
  5: [
    {
      rows: 10,
      cells: [
        { column: 1, columnSpan: 4, row: 1, rowSpan: 5 },
        { column: 5, columnSpan: 8, row: 1, rowSpan: 5 },
        { column: 1, columnSpan: 6, row: 6, rowSpan: 5 },
        { column: 7, columnSpan: 3, row: 6, rowSpan: 5 },
        { column: 10, columnSpan: 3, row: 6, rowSpan: 5 },
      ],
    },
    {
      rows: 8,
      cells: [
        { column: 1, columnSpan: 3, row: 1, rowSpan: 8 },
        { column: 4, columnSpan: 5, row: 1, rowSpan: 4 },
        { column: 9, columnSpan: 4, row: 1, rowSpan: 4 },
        { column: 4, columnSpan: 3, row: 5, rowSpan: 4 },
        { column: 7, columnSpan: 6, row: 5, rowSpan: 4 },
      ],
    },
  ],
  6: [
    {
      rows: 8,
      cells: [
        { column: 1, columnSpan: 3, row: 1, rowSpan: 8 },
        { column: 4, columnSpan: 4, row: 1, rowSpan: 4 },
        { column: 8, columnSpan: 5, row: 1, rowSpan: 4 },
        { column: 4, columnSpan: 3, row: 5, rowSpan: 4 },
        { column: 7, columnSpan: 3, row: 5, rowSpan: 4 },
        { column: 10, columnSpan: 3, row: 5, rowSpan: 4 },
      ],
    },
    {
      rows: 8,
      cells: [
        { column: 1, columnSpan: 5, row: 1, rowSpan: 4 },
        { column: 6, columnSpan: 3, row: 1, rowSpan: 4 },
        { column: 9, columnSpan: 4, row: 1, rowSpan: 4 },
        { column: 1, columnSpan: 3, row: 5, rowSpan: 4 },
        { column: 4, columnSpan: 5, row: 5, rowSpan: 4 },
        { column: 9, columnSpan: 4, row: 5, rowSpan: 4 },
      ],
    },
  ],
};

const MOBILE_PATTERNS = {
  1: [
    {
      rows: 6,
      cells: [{ column: 1, columnSpan: 4, row: 1, rowSpan: 6 }],
    },
  ],
  2: [
    {
      rows: 7,
      cells: [
        { column: 1, columnSpan: 2, row: 1, rowSpan: 7 },
        { column: 3, columnSpan: 2, row: 1, rowSpan: 7 },
      ],
    },
  ],
  3: [
    {
      rows: 8,
      cells: [
        { column: 1, columnSpan: 2, row: 1, rowSpan: 8 },
        { column: 3, columnSpan: 2, row: 1, rowSpan: 4 },
        { column: 3, columnSpan: 2, row: 5, rowSpan: 4 },
      ],
    },
  ],
  4: [
    {
      rows: 8,
      cells: [
        { column: 1, columnSpan: 2, row: 1, rowSpan: 4 },
        { column: 3, columnSpan: 2, row: 1, rowSpan: 4 },
        { column: 1, columnSpan: 1, row: 5, rowSpan: 4 },
        { column: 2, columnSpan: 3, row: 5, rowSpan: 4 },
      ],
    },
    {
      rows: 8,
      cells: [
        { column: 1, columnSpan: 3, row: 1, rowSpan: 4 },
        { column: 4, columnSpan: 1, row: 1, rowSpan: 4 },
        { column: 1, columnSpan: 2, row: 5, rowSpan: 4 },
        { column: 3, columnSpan: 2, row: 5, rowSpan: 4 },
      ],
    },
  ],
  5: [
    {
      rows: 10,
      cells: [
        { column: 1, columnSpan: 2, row: 1, rowSpan: 5 },
        { column: 3, columnSpan: 2, row: 1, rowSpan: 5 },
        { column: 1, columnSpan: 1, row: 6, rowSpan: 5 },
        { column: 2, columnSpan: 1, row: 6, rowSpan: 5 },
        { column: 3, columnSpan: 2, row: 6, rowSpan: 5 },
      ],
    },
  ],
  6: [
    {
      rows: 12,
      cells: [
        { column: 1, columnSpan: 2, row: 1, rowSpan: 4 },
        { column: 3, columnSpan: 2, row: 1, rowSpan: 4 },
        { column: 1, columnSpan: 1, row: 5, rowSpan: 4 },
        { column: 2, columnSpan: 3, row: 5, rowSpan: 4 },
        { column: 1, columnSpan: 3, row: 9, rowSpan: 4 },
        { column: 4, columnSpan: 1, row: 9, rowSpan: 4 },
      ],
    },
  ],
};

const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

const getGap = (containerWidth, variant) => {
  if (containerWidth < 480) return 10;
  if (containerWidth < 760) return 12;
  return variant === 'about' ? 14 : 16;
};

const getGroupHeight = ({ containerWidth, rowCount, itemCount, variant }) => {
  const safeWidth = Math.max(containerWidth, 320);

  if (safeWidth < 640) {
    if (itemCount === 1) return clamp(safeWidth * 0.72, 230, 380);
    const factor = rowCount >= 12 ? 1.28 : rowCount >= 10 ? 1.08 : 0.9;
    return clamp(safeWidth * factor, 300, 560);
  }

  if (safeWidth < 900) {
    const factor = rowCount >= 10 ? 0.78 : 0.64;
    return clamp(safeWidth * factor, 340, 570);
  }

  const factor = rowCount >= 10 ? 0.62 : 0.5;
  const maxHeight = variant === 'about' ? 520 : 650;
  return clamp(safeWidth * factor, rowCount >= 10 ? 380 : 320, maxHeight);
};

const partitionItems = (items, variant) => {
  const preferredSizes =
    variant === 'about' ? [5, 4, 6, 5, 6, 4] : [5, 6, 4, 5, 4, 6];

  const groups = [];
  let cursor = 0;
  let groupIndex = 0;

  while (cursor < items.length) {
    const remaining = items.length - cursor;
    let take = remaining <= 6 ? remaining : preferredSizes[groupIndex % preferredSizes.length];

    // Avoid leaving a single isolated image after a large mosaic when possible.
    if (remaining - take === 1 && take > 4) take -= 1;

    groups.push(items.slice(cursor, cursor + take));
    cursor += take;
    groupIndex += 1;
  }

  return groups;
};

const getPattern = ({ itemCount, groupIndex, isMobile }) => {
  const collection = isMobile ? MOBILE_PATTERNS : DESKTOP_PATTERNS;
  const candidates = collection[itemCount] || collection[1];
  return candidates[groupIndex % candidates.length];
};

export function OrderedGallery({
  images,
  onImageClick,
  altPrefix = 'Galería',
  testId = 'ordered-gallery',
  itemTestIdPrefix = 'ordered-gallery-item',
  variant = 'project',
}) {
  const containerRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);

  const items = useMemo(
    () =>
      (Array.isArray(images) ? images : [])
        .map((src, originalIndex) => ({ src, originalIndex }))
        .filter((item) => typeof item.src === 'string' && item.src.trim().length > 0),
    [images],
  );

  useLayoutEffect(() => {
    const element = containerRef.current;
    if (!element) return undefined;

    const measure = () => {
      const nextWidth = Math.round(element.getBoundingClientRect().width);
      setContainerWidth((currentWidth) =>
        currentWidth === nextWidth ? currentWidth : nextWidth,
      );
    };

    measure();

    if (typeof ResizeObserver !== 'undefined') {
      const observer = new ResizeObserver(measure);
      observer.observe(element);
      return () => observer.disconnect();
    }

    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, []);

  const groups = useMemo(() => partitionItems(items, variant), [items, variant]);
  const safeWidth = containerWidth || 720;
  const isMobile = safeWidth < 640;
  const gap = getGap(safeWidth, variant);
  const isAbout = variant === 'about';

  return (
    <div ref={containerRef} className="w-full" data-testid={testId}>
      <div className="flex w-full flex-col" style={{ gap: `${gap}px` }}>
        {groups.map((group, groupIndex) => {
          const pattern = getPattern({
            itemCount: group.length,
            groupIndex,
            isMobile,
          });
          const groupHeight = getGroupHeight({
            containerWidth: safeWidth,
            rowCount: pattern.rows,
            itemCount: group.length,
            variant,
          });

          return (
            <div
              key={`editorial-group-${groupIndex}`}
              className="grid w-full"
              style={{
                gridTemplateColumns: `repeat(${isMobile ? 4 : 12}, minmax(0, 1fr))`,
                gridTemplateRows: `repeat(${pattern.rows}, minmax(0, 1fr))`,
                gap: `${gap}px`,
                height: `${groupHeight}px`,
              }}
            >
              {group.map(({ src, originalIndex }, itemIndex) => {
                const cell = pattern.cells[itemIndex];
                const alt = `${altPrefix} - foto ${originalIndex + 1}`;

                return (
                  <button
                    key={`${src}-${originalIndex}`}
                    type="button"
                    onClick={() => onImageClick?.(src, originalIndex)}
                    aria-label={`Abrir ${alt}`}
                    className={`relative min-h-0 min-w-0 overflow-hidden group ${
                      isAbout
                        ? 'rounded-2xl border border-white/40 shadow-[0_8px_30px_rgba(0,0,0,0.10)] bg-white/20'
                        : 'rounded-xl border border-[#3A4657]/10 bg-[#3A4657]/5'
                    }`}
                    style={{
                      gridColumn: `${cell.column} / span ${cell.columnSpan}`,
                      gridRow: `${cell.row} / span ${cell.rowSpan}`,
                    }}
                    data-testid={`${itemTestIdPrefix}-${originalIndex}`}
                  >
                    <img
                      src={src}
                      alt={alt}
                      loading="lazy"
                      decoding="async"
                      draggable="false"
                      className={`block h-full w-full object-cover transition-transform duration-500 ${
                        isAbout ? 'group-hover:scale-105' : 'group-hover:scale-[1.03]'
                      }`}
                    />

                    {isAbout ? (
                      <div className="absolute inset-0 bg-black/0 group-hover:bg-black/15 transition-colors" />
                    ) : (
                      <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                        <Expand
                          size={22}
                          className="opacity-0 group-hover:opacity-100 text-white transition-opacity"
                        />
                      </div>
                    )}
                  </button>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default OrderedGallery;
